/**
 * Resource chế độ ghi sổ
 * nnninh 04/05/2023
 */
export default {
  SameTimePosted: 'Cất đồng thời ghi sổ',
  NoSameTimePosted: 'Cất không ghi sổ',
};
